/* eslint-ignore */
// @ts-ignore
// @ts-nocheck

/**
 *
 *
 * @export
 * @param {*} numbers
 * @returns
 */
export default function (numbers) {
  let ddd;
  let firstNumbers;
  let secondNumbers;

  let result;

  numbers = numbers.replace('+55 55', '');
  numbers = numbers.replace('+55', '');
  numbers = numbers.replace('+55 ', '');
  numbers = numbers.replace(/[^\d]/g, '');

  if (numbers.length === 11) {
    ddd = numbers.substring(0, 2);
    firstNumbers = numbers.substring(2, 7);
    secondNumbers = numbers.substring(7, 11);
    result = `(${ddd}) ${firstNumbers}-${secondNumbers}`;
    return result;
  }

  if (numbers.length === 10) {
    ddd = numbers.substring(0, 2);
    firstNumbers = numbers.substring(2, 6);
    secondNumbers = numbers.substring(6, 10);
    result = `(${ddd}) ${firstNumbers}-${secondNumbers}`;
    return result;
  }

  return (result = numbers);
}
